// Small shared pieces of the v2 premium design language, used across screens.

import { Link } from "react-router-dom";

/** Orange rule + uppercase eyebrow label. `tone`: "light" | "onblack" | "orange". */
export function Eyebrow({ children, tone = "light", className = "", ...rest }) {
  const cls =
    tone === "onblack" ? " pd-eyebrow--onblack" : tone === "orange" ? " pd-eyebrow--orange" : "";
  return (
    <div className={`pd-eyebrow-row ${className}`} {...rest}>
      <span className={`pd-eyebrow${cls}`}>{children}</span>
    </div>
  );
}

/** ★★★★★ in solid brand orange, with the rating as its accessible label. */
export function Stars({ count = 5, size = 14, tracking = 2, className = "", ...rest }) {
  return (
    <span
      className={`pd-stars ${className}`}
      style={{ fontSize: size, letterSpacing: tracking }}
      role="img"
      aria-label={`${count} out of 5 stars`}
      {...rest}
    >
      {"★".repeat(count)}
    </span>
  );
}

/**
 * The install demonstration. The footage is 720 × 1280 portrait, so the frame
 * takes the same 9:16 shape and nothing is letterboxed or cropped. Its height
 * is capped against the viewport (.pd-video-portrait) so it never runs taller
 * than a phone screen. preload="none" + poster, so it costs nothing until
 * played. No autoplay.
 */
export function PremiumVideo({ testid = "install-video", className = "" }) {
  return (
    <div className={`pd-video-portrait ${className}`.trim()} data-testid={testid}>
      <video
        controls
        playsInline
        preload="none"
        poster="/videos/staketek-installation-demo-poster.jpg"
        aria-label="Installation demonstration: a StakeTek bracket slid onto a star picket, bolted, and a timber boxing frame screwed to it"
      >
        <source src="/videos/staketek-installation-demo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

/** Orange/dark/outline pill-less square CTA that also works as a router link. */
export function CtaLink({ to, href, children, variant = "orange", size, className = "", ...rest }) {
  const cls = `pd-btn pd-btn--${variant}${size === "sm" ? " pd-btn--sm" : ""} ${className}`.trim();
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <Link to={to} className={cls} {...rest}>{children}</Link>;
}
